import type { ILevelState } from "Interfaces/ILevelState";

export class HUD extends PIXI.Container {
    protected TopLeft = this.addChild(new PIXI.Container());
    protected TopRight = this.addChild(new PIXI.Container());
    protected BottomLeft = this.addChild(new PIXI.Container());
    protected BottomRight = this.addChild(new PIXI.Container());
    protected TopCenter = this.addChild(new PIXI.Container());
    protected BottomCenter = this.addChild(new PIXI.Container());

    protected margin = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    };

    public init(pSize: PIXI.Point, pData: ILevelState) {
        this.onResize(pSize);
        return this;
    }

    public animateIn() {
        //
    }

    public onResize(pSize: PIXI.Point) {
        const minX = -(pSize.x / 2) + this.margin.left;
        const maxX = (pSize.x / 2) - this.margin.right;
        const minY = -(pSize.y / 2) + this.margin.top;
        const maxY = (pSize.y / 2) - this.margin.bottom;

        this.TopLeft.position.set(minX, minY);
        this.TopRight.position.set(maxX, minY);
        this.BottomLeft.position.set(minX, maxY);
        this.BottomRight.position.set(maxX, maxY);
        this.TopCenter.position.set(0, minY);
        this.BottomCenter.position.set(0, maxY);
    }
}
